import { render, staticRenderFns } from "./PersonalDataTab.vue?vue&type=template&id=25c72852&scoped=true"
import script from "./PersonalDataTab.vue?vue&type=script&lang=js"
export * from "./PersonalDataTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c72852",
  null
  
)

export default component.exports